module.exports = __webpack_public_path__ + "static/img/Financial.e276e4bc.jpg";